import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService } from '@core/services/analytics.service';
import { AuthService } from '@core/services/auth.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from '@shared/services/message.service';
import { zip } from 'rxjs';
import { NotificationService } from 'src/app/account/services/notification.service';
import { IUserLoginDto } from '../../interfaces/login.interfaces';
import { LoginService } from '../../services/login.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { LanguageService } from '@shared/services/language.service';
import { EmailService } from '@core/services/email.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    FormsModule,
  ],
})
export class SignInComponent {
  userCredentials: IUserLoginDto = {
    username: '',
    password: '',
  };
  isUsernameEmpty = false;
  isPasswordEmpty = false;
  loginError = false;
  notActivated = false;
  magicLinkSent = false;

  @Input() nextPageRoute: string = 'account';
  @Output() changePage = new EventEmitter<{ to?: 'login' | 'register' | 'reset' | 'magicRequest'; email?: string }>();
  @Output() closeModal = new EventEmitter<Record<string, never>>();

  private loginService = inject(LoginService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private notificationService = inject(NotificationService);
  private messageService = inject(MessageService);
  public activeModal = inject(NgbActiveModal);
  public analyticsService = inject(AnalyticsService);
  private recaptchaV3Service = inject(ReCaptchaV3Service);
  private languageService = inject(LanguageService);
  private emailService = inject(EmailService);

  changePageHandler() {
    this.changePage.emit({});
  }

  openReset() {
    const email = this.userCredentials?.username?.trim()?.toLocaleLowerCase() || '';
    this.changePage.emit({ to: 'reset', email });
  }

  login() {
    this.userCredentials.username = this.userCredentials?.username?.trim()?.toLocaleLowerCase() ?? '';

    if(this.userCredentials.username == '') {
      this.isUsernameEmpty = true;
    } else {
      this.isUsernameEmpty = false;
    }
    if(this.userCredentials.password == '') {
      this.isPasswordEmpty = true;
    } else {
      this.isPasswordEmpty = false;
    }
    if(!this.isUsernameEmpty && !this.isPasswordEmpty) {
      this.loginService.authenticate(this.userCredentials).subscribe((dataR) => {
        if(dataR.authResult === 1) {
          this.loginError = false;
          this.authService.authResult = dataR.authResult;
          this.authService.userLogged = dataR.user;
          if(this.nextPageRoute.startsWith('eventnow')) {
            this.router.navigate([this.nextPageRoute], { relativeTo: this.route });
          } else {
            if(this.nextPageRoute == 'account' && this.authService.userLogged?.idProfile == 1) {
              this.nextPageRoute = 'admin';
            }

            zip(
              this.notificationService.getUnreadNotificationsCount(),
              this.messageService.getCountUnreadMessages()
            ).subscribe(([count, total]) => {
              this.notificationService.unreadNotificationsCount = count;
              this.messageService.unreadMessagesCount = total.unreadMessages;
              this.messageService.startTimer();
              this.router.navigate([this.nextPageRoute], { relativeTo: this.route });
            });

          }

          this.analyticsService.trackLogin();
        } else if(dataR.authResult !== -2) {
          this.loginError = true;
        } else {
          this.notActivated = true;
        }
      });
    }
  }

  sendMagicLink() {
    // navigate to magic link request screen inside the dialog
    const email = this.userCredentials?.username?.trim()?.toLocaleLowerCase() || '';
    this.changePage.emit({ to: 'magicRequest', email });
  }
}
